export const GET_PROJECTS = "GET_PROJECTS";

export const GetProjects = () => {
    return { type: GET_PROJECTS };
};
